import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const HydrotherapyIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = '70', viewBox = '0 0 70 70' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <rect id='Rectangle_889' data-name='Rectangle 889' width='70' height='70' fill='none' />
      <g id='_036---Hydrotherapy' data-name='036---Hydrotherapy' transform='translate(0 8.999)'>
        <path
          id='Shape'
          d='M11.094,34.733H9.374A2.6,2.6,0,0,0,6.934,33H2.6A2.6,2.6,0,0,0,0,35.6V53.8a2.6,2.6,0,0,0,2.6,2.6H6.934a2.587,2.587,0,0,0,1.924-.867H30.594a6.921,6.921,0,0,0,3.6-1.011l16.243-9.888a3.244,3.244,0,0,0-2.714-5.848c-18.069,6.024-16.045,5.481-17.36,5.481,1.05-2.914-1.577-6.067-4.86-6.067H20.974a7.065,7.065,0,0,1-4.4-1.544,8.81,8.81,0,0,0-5.481-1.923ZM6.934,54.667H2.6a.867.867,0,0,1-.867-.867V35.6a.867.867,0,0,1,.867-.867H6.934A.867.867,0,0,1,7.8,35.6V53.8A.867.867,0,0,1,6.934,54.667ZM25.509,39.934c2.3,0,4.3,2.49,2.921,4.333H23.162a8.637,8.637,0,0,0-4.808,1.456l-.635.423a.867.867,0,0,0,.962,1.442A7.33,7.33,0,0,1,23.162,46c8.241,0,8.17.078,9.074-.222L48.28,40.43a1.512,1.512,0,0,1,1.265,2.723L33.3,53.042a5.2,5.2,0,0,1-2.7.758H9.534V36.467c1.969,0,3.839-.152,5.959,1.544a8.81,8.81,0,0,0,5.482,1.923Z'
          transform='translate(0 -4.399)'
          fill={fill}
        />
        <path
          id='Shape-2'
          data-name='Shape'
          d='M35.867,32.934c7.646,0,13.867-5.8,13.867-12.922C49.734,13.066,37.009.762,36.467.242a.867.867,0,0,0-1.2,0C34.726.762,22,13.066,22,20.013,22,27.138,28.221,32.934,35.867,32.934Zm0-30.854C39.746,5.927,48,15.129,48,20.015,48,26.182,42.558,31.2,35.867,31.2S23.733,26.182,23.733,20.013c0-4.886,8.254-14.088,12.134-17.933Z'
          transform='translate(-2.933 0)'
          fill={fill}
        />
        <path
          id='Shape-3'
          data-name='Shape'
          d='M30.733,24.4H34.2v3.467A1.733,1.733,0,0,0,35.934,29.6h1.733A1.733,1.733,0,0,0,39.4,27.867V24.4h3.467A1.733,1.733,0,0,0,44.6,22.667V20.934A1.733,1.733,0,0,0,42.867,19.2H39.4V15.733A1.733,1.733,0,0,0,37.667,14H35.934A1.733,1.733,0,0,0,34.2,15.733V19.2H30.733A1.733,1.733,0,0,0,29,20.934v1.733A1.733,1.733,0,0,0,30.733,24.4Zm0-3.467H34.2A1.733,1.733,0,0,0,35.934,19.2V15.733h1.733V19.2A1.733,1.733,0,0,0,39.4,20.934h3.467v1.733H39.4A1.733,1.733,0,0,0,37.667,24.4v3.467H35.934V24.4A1.733,1.733,0,0,0,34.2,22.667H30.733Z'
          transform='translate(-3.866 -1.866)'
          fill={fill}
        />
      </g>
    </svg>
  )
);
HydrotherapyIcon.displayName = 'HydrotherapyIcon';

export default HydrotherapyIcon;
